<template>
  <div id="app2">
    <BusinessCard />
  </div>
</template>

<script>
import BusinessCard from "./components/BusinessCard.vue";

export default {
  name: "App",
  components: {
    BusinessCard,
  },
};
</script>

<style>
#app2 {
  font-family: "Poppins", serif;
  font-weight: 200;
  font-style: normal;
  width: 100%;
}
</style>
